import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import type { NewPayment } from '@/models/payments';
import type { ColumnDef } from '@tanstack/vue-table';
import { ArrowUpDown } from 'lucide-vue-next';
import { h } from 'vue';

export const paymentsRegisterColumns: ColumnDef<NewPayment>[] = [
  {
    accessorKey: 'client',
    header: 'Customer Name',
    enableSorting: false,
    cell: ({ getValue }) => {
      const name = getValue() as string;
      return h('div', { class: 'font-medium' }, name);
    },
  },
  {
    accessorKey: 'orderReference',
    header: 'Order Reference',
    enableSorting: false,
    cell: ({ getValue }) => {
      const name = getValue() as string;
      return h('div', name);
    },
  },
  {
    accessorKey: 'orderName',
    header: 'Order Name',
    enableSorting: false,
    cell: ({ getValue }) => getValue(),
  },
  {
    accessorKey: 'paymentType',
    header: 'Payment Type',
    enableSorting: false,
    cell: ({ getValue }) => getValue(),
  },
  {
    accessorKey: 'paymentMethod',
    header: 'Method',
    enableSorting: false,
    cell: ({ getValue }) => getValue(),
  },
  {
    accessorKey: 'settlementBatch',
    header: 'Settlement Batch',
    enableSorting: false,
    cell: ({ getValue }) => getValue(),
  },
  {
    accessorKey: 'due',
    header: 'Due Date',
    enableSorting: false,
    cell: ({ getValue }) => getValue(),
  },
  {
    accessorKey: 'amount',
    header: 'Amount',
    enableSorting: false,
    cell: ({ getValue }) => getValue(),
  },
  {
    accessorKey: 'fee',
    header: 'Fee',
    enableSorting: false,
    cell: ({ getValue }) => getValue(),
  },
  {
    accessorKey: 'paymentStatus',
    header: 'Status',
    enableSorting: false,
    cell: ({ getValue }) => {
      const state = getValue() as string;
      let variant: 'error' | 'success' | 'warning' | 'info' = 'success';

      if (state === 'FAILED') variant = 'error';
      if (state === 'DUE' || state === 'MISSED') variant = 'warning';
      if (state === 'SETTLED' || state === 'PENDING') variant = 'info';

      return h(Badge, { class: 'text-xs', variant }, () => state);
    },
  },
  {
    accessorKey: 'verifiedAt',
    header: 'Date Paid',
    enableSorting: false,
    cell: ({ getValue }) => getValue(),
  },
];
